import { PackageMiscellaneousFormWebComponent } from './component/PackageMiscellaneousFormWebComponent';
import { WEB_COMPONENT_PACKAGE_MISCELLANEOUS_FORM } from '../../../webcomponents.constants';

export { PackageMiscellaneousFormWebComponent };

window.customElements.define(WEB_COMPONENT_PACKAGE_MISCELLANEOUS_FORM, PackageMiscellaneousFormWebComponent);
